import React, { useState, createContext, ReactNode, useContext } from "react"

type TBaseContext = {
  currencySymbol: string
  setCurrencySymbol: React.Dispatch<React.SetStateAction<string>>
  isAdmin: boolean
  setIsAdmin: React.Dispatch<React.SetStateAction<boolean>>
}

const BaseContext = createContext<TBaseContext>({
  currencySymbol: "$",
  setCurrencySymbol: () => {},
  isAdmin: false,
  setIsAdmin: () => {},
})

const BaseContextProvider = ({ children }: { children: ReactNode }) => {
  const [currencySymbol, setCurrencySymbol] = useState("$")
  const [isAdmin, setIsAdmin] = useState(false)
  const initialBaseContextValues = {
    currencySymbol,
    setCurrencySymbol,
    isAdmin,
    setIsAdmin,
  }

  return (
    <BaseContext.Provider value={initialBaseContextValues}>
      {children}
    </BaseContext.Provider>
  )
}

BaseContextProvider.displayName = "BaseContextProvider"

const useBaseContext = () => {
  return useContext(BaseContext)
}

export { BaseContextProvider, useBaseContext }
